import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stethoscope',
  templateUrl: './stethoscope.component.html',
  styleUrls: ['./stethoscope.component.scss']
})
export class StethoscopeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
